import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import Slider from "react-slick";
import Swal from "sweetalert2";
import BaseUrl from "../../BaseUrl";
import Footer from "../Layout/Footer";
import Header from "../Layout/Header";

const PackagePlan = () => {
  window.sessionStorage.setItem("prevPath", window.location.pathname);

  const Details = useSelector((state) => state.auth.auth);
  const history = useHistory();
  const [plans, setPlans] = useState([]);
  const [loader, setLoader] = useState(false);
  const settings = {
    arrows: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: plans?.plans?.length > 3 ? 3 : 1,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: false,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          dots: false,
          arrows: false,
        },
      },
    ],
  };
  const Packages = () => {
    setLoader(true);
    var config = {
      method: "get",
      url: `${BaseUrl.baseurl}/plans/index`,
    };

    axios(config)
      .then(function (response) {
        setLoader(false);
        setPlans(response?.data);
        console.log(response?.data);
      })
      .catch(function (error) {
        setLoader(false);

        console.log(error?.response);
        // setFielderr(error?.response?.data?.errors);
        Swal.fire({
          showCloseButton: true,
          toast: true,
          icon: "error",
          title: error.response.data.message,
          animation: true,
          position: "top-right",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      });
  };
  useEffect(() => {
    Packages();
  }, []);

  var bnr3 = require("./../../images/lines.png");

  return (
    <>
      {loader ? <div className="loader"></div> : null}
      <Header />
      <div
        className="section-full content-inner-2 overlay-white-middle"
        style={{
          backgroundImage: "url( " + bnr3 + ")",
          backgroundPosition: "bottom",
          backgroundRepeat: "no-repeat",
          backgroundSize: "100%",
        }}
      >
        <div className="container">
          <div className="section-head text-black text-center">
            <h2 className="m-b0">Membership Plans</h2>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy.
            </p>
          </div>

          <Slider {...settings}>
            {plans?.plans
              ? plans?.plans?.map((e, i) => {
                  return (
                    <>
                      {i % 2 === 0 ? (
                        <>
                          <div className="offset-md-1 col-md-10 offset-md-1 ">
                            <div className="pricingtable-wrapper style2 bg-white">
                              <div className="pricingtable-inner">
                                <div className="pricingtable-price">
                                  <h4 className="font-weight-300 m-t10 m-b0">
                                    {e?.name}
                                  </h4>
                                  <div className="pricingtable-bx">
                                    $ <span>{e?.price}</span> / Per&nbsp;
                                    {e?.duration}&nbsp;{e?.period}{" "}
                                  </div>
                                </div>
                                <p>{e?.description}</p>
                                <div className="m-t20">
                                  <Link
                                    to={"#"}
                                    onClick={() => {
                                      history.push(
                                        `/Checkout/${e?.id}/${Details?.user?.email}/${Details?.user?.id}`
                                      );
                                    }}
                                    className="site-button radius-xl"
                                  >
                                    <span className="p-lr30">Buy Now</span>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : null}
                      {i % 2 !== 0 ? (
                        <>
                          <div className="offset-md-1 col-md-10 offset-md-1">
                            <div className="pricingtable-wrapper style2 bg-info text-white active">
                              <div className="pricingtable-inner">
                                <div className="pricingtable-price">
                                  <h4 className="font-weight-300 m-t10 m-b0">
                                    {e?.name}
                                  </h4>
                                  <div className="pricingtable-bx">
                                    $ <span>{e?.price}</span> / Per&nbsp;
                                    {e?.duration}&nbsp;{e?.period}{" "}
                                  </div>
                                </div>
                                <p>{e?.description}</p>
                                <div className="m-t20">
                                  <Link
                                    to={"#"}
                                    onClick={() => {
                                      history.push(
                                        `/Checkout/${e?.id}/${Details?.user?.email}/${Details?.user?.id}`
                                      );
                                    }}
                                    className="site-button radius-xl "
                                  >
                                    <span className="p-lr30 ">Buy Now</span>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : null}
                    </>
                  );
                })
              : null}
          </Slider>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PackagePlan;
